<template>
  <div>
    <van-nav-bar
      title="新增预订单"
      :left-text="'您好，' + userInfo.emp_name"
    />
    <van-form ref="form" validate-first @failed="toast('请完善订单信息')">
      <van-tabs v-model="active">
        <van-tab title="订货信息">
          <van-col :span="20">
            <base-input v-model="form.code" label="订单号" readonly />
          </van-col>
          <van-col :span="4" style="margin-top: 10px;">
            <order-code :type="type" @getCode="form.code = $event" />
          </van-col>
          <van-col :span="24">
            <van-search v-model="form.orderer_phone" label="会员手机号"
                        placeholder="会员手机号" :rules="[{ required: true, message: '请输入手机号' }]"
                        @input="onInputOfOrderPhone" />
          </van-col>
          <van-col :span="24">
            <base-input v-model="form.orderer" label="会员姓名" required />
          </van-col>
          <van-col :span="24">
            <base-textarea v-model="form.orderer_addr" label="订货地址" required />
          </van-col>
          <van-col v-if="userInfo.source_ids" :span="24">
            <base-select v-model="form.source_id" label="订单来源" :options="form.sourceList" />
          </van-col>
          <van-col v-else :span="24" @click="showSearchListOfClient = true">
            <base-input v-model="form.source_name" label="订单来源" required readonly />
          </van-col>
          <van-col :span="24">
            <base-textarea v-model="form.remark" label="备注" />
          </van-col>
          <van-popup v-model="showSearchListOfClient" :style="{ height: '60%' }" position="bottom">
            <base-search-client-list @change="onConfirmOfSelectClient" />
          </van-popup>
        </van-tab>
        <van-tab title="产品信息">
          <van-col :span="8" style="text-align: left; padding-left: 10px;">
            <base-button @click="add">新增</base-button>
          </van-col>
          <van-col :span="16">
            <base-input-number v-model="form.dis_amount" label="优惠金额" @change="onDisAmountChange" />
          </van-col>
          <van-col v-for="(detail, index) in form.details" :key="detail.key" :span="24">
            <van-swipe-cell>
              <van-card :num="detail.count" :price="detail.price" :desc="detail.name" :title="'产品' + (index + 1)"
                        thumb="https://img.yzcdn.cn/vant/ipad.jpeg" @click="onSelectGoods(detail)">
                <div slot="tags">
                  <van-tag v-if="detail.type" plain type="danger">{{ detail.type }}</van-tag>
                  <van-tag v-if="detail.specs" plain type="primary">{{ detail.specs }}</van-tag>
                </div>
                <div slot="footer">
                  <van-col :span="4">
                    <base-button type="danger" size="mini" @click="del(detail)">删除</base-button>
                  </van-col>
                  <van-col :span="4">
                    <base-button type="warning" size="mini" @click="gift(detail)">礼品</base-button>
                  </van-col>
                  <van-col :span="4">
                    <base-button type="info" size="mini" @click="showDetails(detail)">详情</base-button>
                  </van-col>
                  <van-col :span="2" :offset="8">
                    <van-icon name="clear" color="#ff4949"
                              size="20" @click.stop="onCountChange(detail, 'reduce')" />
                  </van-col>
                  <van-col :span="2">
                    <van-icon name="add" color="#07c160"
                              size="20" @click.stop="onCountChange(detail, 'increase')" />
                  </van-col>
                </div>
              </van-card>
              <van-col :span="10">
                <base-input-number v-model="detail.discount" label="折扣"
                                   @change="onCountOrDiscountChange(detail, true)" />
              </van-col>
              <van-col :span="12">
                <base-input-number v-model="detail.amount" label="小计"
                                   @change="onAmountChange(detail)" />
              </van-col>
              <van-col :span="24">
                <base-input-number v-model="detail.count" label="数量"
                                   @change="onCountOrDiscountChange(detail, true)" />
              </van-col>
              <van-col :span="24">
                <base-textarea v-model="detail.remark" label="特殊要求" />
              </van-col>
              <base-button slot="right" type="danger" size="mini" class="delete-button"
                           @click="del(detail)">删除</base-button>
            </van-swipe-cell>
          </van-col>
          <van-popup v-model="showSearchList" :style="{ height: '80%' }" position="bottom">
            <base-search-goods-list @change="onConfirmOfSelectGoods" />
          </van-popup>
        </van-tab>
        <van-tab title="支付信息">
          <van-row>
            <van-col :span="8" style="text-align: left; padding-left: 10px;">
              <base-button @click="addPay">新增</base-button>
            </van-col>
            <van-col :span="16">
              <base-input-number v-model="form.dis_amount" label="优惠金额" @change="onDisAmountChange" />
            </van-col>
          </van-row>
          <van-row v-for="(pay, index) in form.pay_details" :key="pay.key">
            <van-col :span="24">
              <base-select v-model="pay.pay_agreed_id" :label="'支付约定' + (index + 1)" :options="payAgreedList" />
            </van-col>
            <van-col :span="24">
              <base-select v-model="pay.pay_type_id" :label="'支付方式' + (index + 1)" :options="payTypeList" />
            </van-col>
            <van-col :span="20">
              <base-input-number v-model="pay.amount" label="金额" />
            </van-col>
            <van-col :span="4">
              <base-button type="danger" size="mini" @click="delPay(pay)">删除</base-button>
            </van-col>
          </van-row>
        </van-tab>
        <van-tab title="配送信息">
          <base-datetime v-model="form.delivery_time" label="送货时间" required />
          <base-select v-model="form.express_delivery_id" label="配送方式" :options="expressDeliveryList" />
          <base-input v-model="form.express_delivery_code" label="速递单号" />
          <van-col :span="24" style="text-align: right; padding-right: 10px;">
            <base-button @click="sameAsOrderer">与订货人相同</base-button>
          </van-col>
          <base-input-select v-model="form.receiver" label="收货人"
                             :options="form.receiverList" required />
          <base-input-select v-model="form.receiver_phone" label="收货人电话"
                             :options="form.receiverPhoneList" required />
          <base-textarea v-model="form.receiver_addr" label="收货人地址" :show-select="true"
                         :rows="5" :options="form.receiverAddrList" required />
          <van-col :span="24">
            <base-textarea v-model="form.remark" label="备注" />
          </van-col>
        </van-tab>
      </van-tabs>
      <van-submit-bar :loading="saveLoading" :price="form.receivable_amount * 100"
                      label="应收：" button-text="提交" :safe-area-inset-bottom="true" @submit="save">
        <span style="color: gray; font-size: 14px; font-style: italic; text-decoration: line-through;">
          （原价：{{ form.total_amount | toThousandFilter }}）
        </span>
        <span slot="tip">
          总数量：{{ form.total_count | toThousandFilter }}&nbsp;&nbsp;&nbsp;&nbsp;
          合计：{{ form.sell_amount | toThousandFilter }}
        </span>
      </van-submit-bar>
    </van-form>

    <init :init-states="initStates" @after-init="init" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Init from '@/components/base/init'
import OrderCode from '@/components/base/order-code'
import { getOrderCode } from '@/api/commons'
import { addSellOrder, modifySellOrder } from '@/api/sell/order'
import { getMemberList, getMemberDiscountList } from '@/api/settings/member'
export default {
  name: 'SellOrder',
  components: { Init, OrderCode },
  data() {
    return {
      loading: false,
      saveLoading: false,
      active: 0,
      showSearchList: false,
      showSearchListOfClient: false,
      type: this.CONST.ORDER_BILL_TYPES.find(type => type.name === '销售预订单').id,

      selectedRow: null,

      formModel: {},
      form: {
        code: '',
        order_date: '',
        selectedOrderer: null,
        isClient: false,
        orderer_type: this.CONST.ORDERER_TYPE.find(type => type.name === '会员').id,
        orderer_id: null,
        orderer: '',
        orderer_phone: '',
        orderer_addr: '',
        pay_details: [],
        details: [],
        receiver: '',
        receiverList: [],
        receiver_phone: '',
        receiverPhoneList: [],
        receiver_addr: '',
        receiverAddrList: [],
        delivery_time: '',
        express_delivery_id: null,
        express_delivery_code: '',
        source_id: null,
        source_name: '',
        sourceList: [],
        score: 0,
        remark: '',
        total_count: 0, // 总数量
        total_amount: 0, // 总金额（原值）
        sell_amount: 0, // 总金额（折后）
        dis_amount: 0, // 优惠金额
        receivable_amount: 0 // 应收金额
      },
      newRowOfGoods: {
        key: 0,
        name: '',
        type: '',
        code: '',
        selectedGoods: null,
        goods_id: null,
        goodsIdsArray: [],
        specs: '',
        discount: 10,
        count: 1,
        price: 0,
        amount: 0,
        remark: ''
      },
      newRowOfPay: {
        key: 0,
        pay_agreed_id: null,
        pay_type_id: null,
        amount: 0
      },
      initStates: [{
        key: 'goods/init'
      }, {
        key: 'dict/initPayTypeList'
      }, {
        key: 'dict/initPayAgreedList'
      }, {
        key: 'dict/initExpressDeliveryList'
      }]
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'goodsMapOfIdsArray', 'goodsMapOfId',
      'payTypeList', 'payAgreedList', 'expressDeliveryList'])
  },
  methods: {
    init() {
      this.loading = true
      this.loadForm()
    },
    queryOrderCode(type) {
      getOrderCode({
        type: type
      }).then(resp => {
        this.form.code = resp.obj || ''
      })
    },
    calcTotalCountAndAmount() {
      let total_count = 0
      let total_amount = 0
      let sell_amount = 0
      if (this.form.details && this.form.details.length > 0) {
        this.form.details.forEach(row => {
          total_count = parseFloat((total_count + parseFloat(row.count || 0))
            .toFixed(this.CONST.DECIMAL.DEFAULT_PRECISION))
          total_amount = parseFloat((total_amount + parseFloat(row.count || 0) * (row.price || 0))
            .toFixed(this.CONST.DECIMAL.DEFAULT_PRECISION))
          sell_amount = parseFloat((sell_amount + parseFloat(row.amount || 0)).toFixed(this.CONST.DECIMAL.DEFAULT_PRECISION))
        })
      }
      this.form.total_count = total_count
      this.form.total_amount = total_amount
      this.form.sell_amount = sell_amount
      this.onDisAmountChange()
    },
    validData() {
      let count = 0
      for (let i = 0, j = this.form.details.length; i < j; i++) {
        const row = this.form.details[i]
        if (row.goods_id) {
          if (!row.count) {
            this.error(`第 ${i + 1} 行数量不能为空`)
            return false
          }
          count++
        }
      }
      if (count > 0) {
        if (this.form.pay_details && this.form.pay_details.length > 0) {
          let payTotalAmount = 0
          this.form.pay_details.forEach(pay => {
            payTotalAmount += parseFloat(parseFloat(pay.amount).toFixed(this.CONST.DECIMAL.DEFAULT_PRECISION))
          })
          if (payTotalAmount === this.form.receivable_amount) {
            return true
          } else {
            this.error('支付明细的合计金额不等于应收金额，请调整')
            return false
          }
        } else {
          return true
        }
      } else {
        this.error('单据明细不能为空，请您至少添加一条记录')
        return false
      }
    },
    save() {
      this.$refs['form'].validate().then(_ => {
        if (this.validData()) {
          this.saveLoading = true
          this.form.total_amount = this.form.total_amount || 0
          this.form.sell_amount = this.form.sell_amount || 0
          this.form.dis_amount = this.form.dis_amount || 0
          this.form.receivable_amount = this.form.receivable_amount || 0
          this.form.score = this.form.score || 0

          const data = this._.cloneDeep(this.form)
          data.details = []
          this.form.details.forEach(detail => {
            if (detail.goods_id) {
              data.details.push(this._.cloneDeep(detail))
            }
          })
          if (data.id > 0) {
            modifySellOrder(data).then(resp => {
              this.success(resp.msg)
            })
          } else {
            addSellOrder(data).then(resp => {
              this.success(resp.msg)
              this.confirm('是否清空表单？').then(() => {
                this.resetForm()
              }).catch(() => {
                this.queryOrderCode(this.type)
              })
            })
          }
        } else {
          toast('请完善订单信息')
        }
        this.saveLoading = false
      }).catch(error => {})
    },
    onInputOfOrderPhone(val) {
      const keywords = val.trim()
      if (keywords.length === 11) {
        getMemberList({
          name: keywords
        }).then(resp => {
          const rows = resp.rows || []
          if (rows.length > 0) {
            this.form.selectedOrderer = rows[0]
            this.form.orderer_id = this.form.selectedOrderer.id
            this.form.orderer = this.form.selectedOrderer.name
            this.form.orderer_addr = this.form.selectedOrderer.address

            let receivers = []
            if (this.form.isClient) {
            } else {
              receivers = this.form.selectedOrderer.member_receivers
              getMemberDiscountList({
                page: this.CONST.PAGINATION.PAGE,
                rows: this.CONST.PAGINATION.MAX_ROWS,
                sort: 'id',
                order: 'desc',
                member_id: this.form.selectedOrderer.id
              }).then(resp => {
                const discountRows = resp.rows || []
                this.form.selectedOrderer.discountMap = []
                discountRows.forEach(discount => {
                  this.form.selectedOrderer.discountMap[discount.goods_type_id] = discount
                })
                this.onDiscountChangeOfOrderer()
              })
            }
            if (receivers && receivers.length > 0) {
              receivers.forEach(receiver => {
                this.form.receiverList.push({
                  name: receiver.receiver
                })
                this.form.receiverPhoneList.push({
                  name: receiver.receiver_phone
                })
                this.form.receiverAddrList.push({
                  name: receiver.receiver_addr
                })
              })
            }
          }
        })
      } else {
        this.form.selectedOrderer = null
        this.form.orderer_id = null
        this.form.orderer = ''
        this.form.orderer_addr = ''
      }
    },
    onConfirmOfSelectGoods(goods) {
      this.selectedRow.name = goods.name
      this.selectedRow.type = goods.type_names
      this.selectedRow.goodsIdsArray = this.goodsMapOfIdsArray[goods.id]
      this.selectedRow.goods_id = goods.id
      this.selectedRow.selectedGoods = goods
      this.selectedRow.code = goods.code
      this.selectedRow.price = goods.base_price
      this.selectedRow.specs = goods.specs
      this.selectedRow.tag = false
      this.onCountOrDiscountChange(this.selectedRow, true)
      this.showSearchList = false
    },
    onDiscountChangeOfOrderer() {
      if (this.form.selectedOrderer && this.form.selectedOrderer.discountMap &&
        this.form.selectedOrderer.discountMap.length > 0) {
        this.form.details.forEach(row => {
          if (row.selectedGoods) {
            const discountObj = this.form.selectedOrderer.discountMap[row.selectedGoods.type_id]
            row.discount = discountObj ? discountObj.discount : 10
            row.tag = false
            this.onCountOrDiscountChange(row, false)
          }
        })
        this.calcTotalCountAndAmount()
      }
    },
    onConfirmOfSelectClient(client) {
      this.form.source_name = client.name
      this.form.source_id = client.id
      this.showSearchListOfClient = false
    },
    onCountOrDiscountChange(row, calcTotal) {
      if (row.tag) {
        row.tag = false
      } else {
        row.amount = parseFloat((parseFloat(row.discount || 0) / 10 * parseFloat(row.count || 0) * parseFloat(row.price || 0))
          .toFixed(this.CONST.DECIMAL.DEFAULT_PRECISION))
        if (calcTotal) {
          this.calcTotalCountAndAmount()
        }
      }
    },
    onAmountChange(row) {
      row.tag = true
      if (!row.count) {
        row.count = 1
      }
      row.discount = parseFloat((parseFloat(row.amount || 0) / parseFloat(row.count * (row.price || 1)) * 10)
        .toFixed(this.CONST.DECIMAL.DEFAULT_PRECISION))
      if (row.discount === 0) {
        row.discount = 10
      }
      this.calcTotalCountAndAmount()
    },
    onDisAmountChange() {
      this.form.receivable_amount = parseFloat((this.form.sell_amount - parseFloat(this.form.dis_amount || 0))
        .toFixed(this.CONST.DECIMAL.DEFAULT_PRECISION))
      this.form.score = this.form.receivable_amount
      // 当支付形式只有一种时，应收金额填入该支付形式的金额中
      if (this.form.pay_details && this.form.pay_details.length === 1) {
        this.form.pay_details[0].amount = this.form.receivable_amount
      }
    },
    onCountChange(detail, type) {
      if (type === 'increase') {
        detail.count++
      } else if (type === 'reduce') {
        detail.count > 1 ? detail.count-- : detail.count
      }
      this.onCountOrDiscountChange(detail, true)
    },
    onSelectGoods(row) {
      this.selectedRow = row
      this.showSearchList = true
    },
    resetForm(isModify) {
      this.Utils.resetValue(this.form)
      this.form.orderer_type = this.CONST.ORDERER_TYPE.find(type => type.name === '会员').id
      if (this.expressDeliveryList && this.expressDeliveryList.length > 0) {
        this.form.express_delivery_id = this.expressDeliveryList[0].id
      }
      this.form.isClient = false
      this.form.sourceList = []
      const sourceIdList = this.userInfo.source_ids
        ? this.userInfo.source_ids.split(',') : []
      const sourceNameList = this.userInfo.source_names
        ? this.userInfo.source_names.split(',') : []
      for (let i = 0, j = sourceIdList.length; i < j; i++) {
        this.form.sourceList.push({
          id: parseInt(sourceIdList[i]),
          name: sourceNameList[i]
        })
      }
      if (this.form.sourceList && this.form.sourceList.length > 0) {
        this.form.source_id = parseInt(this.form.sourceList[0].id)
        this.form.source_name = this.form.sourceList[0].name
      }
      this.add()
      this.addPay()
      if (!isModify) {
        this.queryOrderCode(this.type)
      }
      this.form.delivery_time = this.Utils.df(null, '{y}-{m}-{d} {h}:{i}:{s}')
      this.form.order_date = this.Utils.df(null, '{y}-{m}-{d} {h}:{i}:{s}')
    },
    loadForm() {
      const data = localStorage.getItem('sellOrderFormModel')
      if (data) {
        this.formModel = JSON.parse(data)
        localStorage.removeItem('sellOrderFormModel')
        if (this.formModel.id > 0 || this.formModel.loadFormModel) {
          this.resetForm(true)
          // 克隆一份formModel，防止列表对象被修改
          Object.assign(this.form, this._.cloneDeep(this.formModel))
          this.form.isClient = this.form.orderer_type === this.CONST.ORDERER_TYPE.find(type => type.name === '渠道商').id
          if (this.formModel.loadFormModel) {
            this.form.order_date = this.Utils.df(null, '{y}-{m}-{d} {h}:{i}:{s}')
            this.queryOrderCode(this.type)
          }
          this.form.details.forEach(detail => {
            detail.selectedGoods = this.goodsMapOfId[detail.goods_id]
            detail.goodsIdsArray = this.goodsMapOfIdsArray[detail.goods_id]
            this.form.total_count += detail.count
          })
        } else {
          this.resetForm()
        }
        this.loading = false
      } else {
        this.resetForm()
        this.loading = false
      }
    },
    delPay(row) {
      const index = this.form.pay_details.indexOf(row)
      if (index !== -1) {
        this.form.pay_details.splice(index, 1)
      }
    },
    addPay(index) {
      const newRow = Object.assign({}, this.newRowOfPay)
      newRow.key = this.Utils.createUniqueString()
      if (this.payAgreedList && this.payAgreedList.length > 0) {
        newRow.pay_agreed_id = this.payAgreedList[0].id
      }
      if (this.payTypeList && this.payTypeList.length > 0) {
        newRow.pay_type_id = this.payTypeList[0].id
      }
      if (index) {
        this.form.pay_details.splice(index, 0, newRow)
      } else {
        this.form.pay_details.push(newRow)
      }
    },
    sameAsOrderer() {
      this.form.receiver = this.form.orderer
      this.form.receiver_phone = this.form.orderer_phone
      this.form.receiver_addr = this.form.orderer_addr
    },
    gift(row) {
      row.discount = 0
      this.onCountOrDiscountChange(row, true)
    },
    showDetails(row) {},
    add() {
      const newRow = Object.assign({}, this.newRowOfGoods)
      newRow.key = this.Utils.createUniqueString()
      this.form.details.push(newRow)
    },
    del(row) {
      if (this.form.details.length > 0) {
        const index = this.form.details.indexOf(row)
        if (index !== -1) {
          this.form.details.splice(index, 1)
          this.calcTotalCountAndAmount()
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sell/order.vue